import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getvariantQueryMode } from "../../../../state/selectors/general.selectors";
import { areEqual } from "../../../../common/helpers/helpers";
import { drawData } from "./helpers/helpers";

const { arrayOf, shape, string, oneOfType, number } = PropTypes;

const RPKMExpressions = ({
  uniqueKey,
  data,
  yAxisTitle,
  xAxisTitle,
  variantQueryMode,
}) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);

  useEffect(() => {
    setContainerWidth(Math.max(containerRef.current.clientWidth, 1000));
  }, []);

  useEffect(() => {
    if (data) {
      drawData(
        data,
        containerRef,
        containerWidth,
        uniqueKey,
        yAxisTitle,
        xAxisTitle,
        variantQueryMode
      );
    }
  }, [uniqueKey, data, yAxisTitle, xAxisTitle, containerWidth]);

  return (
    <div
      className="tw-w-full tw-overflow-x-auto"
      ref={containerRef}
      id={`rpkm_expressions_d3${uniqueKey}`}
    >
      {data ? <svg height="500" /> : null}
    </div>
  );
};

RPKMExpressions.propTypes = {
  data: arrayOf(
    shape({
      expression: string,
      value: oneOfType([string, number]),
    })
  ),
  yAxisTitle: string,
  xAxisTitle: string,
  uniqueKey: string,
  variantQueryMode: shape({
    age: string,
    annotation_mode: string,
    diseases: PropTypes.oneOfType([arrayOf(string), string]),
    ethnicity: string,
    familyMembersAffected: string,
    inheritance: string,
    phenotypes: PropTypes.oneOfType([arrayOf(string), string]),
    sex: string,
    zygosity: string,
  }),
};

RPKMExpressions.defaultProps = {
  data: null,
  yAxisTitle: "",
  xAxisTitle: "",
  uniqueKey: "",
  variantQueryMode: {
    annotation_mode: "",
    cancer_type: "",
    tissue_type: "",
    age: "",
    ethnicity: "",
    sex: "",
    phenotypes: "",
    diseases: "",
    zygosity: "",
    inheritance: "",
    familyMembersAffected: "",
  },
};

const mapStateToProps = (state) => ({
  variantQueryMode: getvariantQueryMode(state),
});

export default connect(mapStateToProps)(React.memo(RPKMExpressions, areEqual));
